import React, {Fragment, useMemo} from 'react';
import {connect} from "react-redux";
import SqftStore from "../../../../../canvas/store/sqftStore";
import EventManager from "../../../../../canvas/store/sqftEventManager";
import config from "../../../../../canvas/store/sqftConfig";
import Radius from "../../../../../canvas/core/controls/radius";
import {getCurrentLayout} from "../../../../../../../appLayout";
import {getNavItems} from "../../../../../../helpers/sqftHelperUi";

//Clipped Corners
const SqftNav45Corner = (props) => {
  const {visualizersLoaded} = props;
  const [activeItemIndex, setActiveItemIndex] = React.useState(0);
  const maxRadiusCorner = 30;
  const featureGroupName = 'corners';
  const staticLowesFeatureGroupName = 'radius';
  const staticLowesFeatureName = 'Clipped Corners (over 3 inches)';

  const layout = getCurrentLayout();
  let featureGroup;
  let isRadiiFeatures;
  if (visualizersLoaded.length) {
    featureGroup = layout.getSubPartFromQtCategories(featureGroupName);
  }

  const cornersNavItems = useMemo(() => {
    if (visualizersLoaded.length) {
      let cornersNavItems = getNavItems(featureGroup, "", {}, false, true);
      cornersNavItems = cornersNavItems.filter((navItem) => {
        return parseInt(navItem.part.dbFeature.sharedFeatureName)
      });
      cornersNavItems.sort((a, b) => parseInt(a.part.dbFeature.sharedFeatureName) - parseInt(b.part.dbFeature.sharedFeatureName));

      return cornersNavItems
    }
    return []
  }, [visualizersLoaded, featureGroup]);

  const staticFeature = useMemo(() => {
    if (visualizersLoaded.length) {
      const staticFeatureGroup = layout.getSubPartFromQtCategories(staticLowesFeatureGroupName);
      return getNavItems(staticFeatureGroup, staticLowesFeatureName, {}, false, true);
    }
    return []
  }, [layout, visualizersLoaded]);

  isRadiiFeatures = !!featureGroup && cornersNavItems.length > 0;

  const getHardcodedCorners = () => {
    const maxRadius = 60;
    let corners = [], i = 0;
    while (i < maxRadius) {
      i += 3;
      corners.push(i);
    }

    return corners
  }

  const cornersToDisplay = useMemo(() => {
    if (visualizersLoaded.length) {
      if (isRadiiFeatures) {
        return cornersNavItems
      } else {
        return getHardcodedCorners();
      }
    }
    return []
  }, [visualizersLoaded, isRadiiFeatures, cornersNavItems]);

  const handleButtonClick = function(e, value, navItem) {
    void e;
    const getCornerFeatureId = (navItem, value) => {
      //This hardcode is for Lowes
      if (staticFeature.length > 0 && value > 3) {
        return staticFeature[0].part.dbFeature.id
      }
      return navItem.part ? navItem.part.dbFeature.id : null
    }
    setActiveItemIndex(value);
    deregisterEvents();
    SqftStore.radius.arcLength = 0;
    SqftStore.radius.angle = value;
    SqftStore.radius.featureId = getCornerFeatureId(navItem, value);

    console.log("SqftStore.radius.angle", SqftStore.radius.angle);
    console.log("SqftStore.radius.featureId", SqftStore.radius.featureId);
    Radius.handleButtonClick(value);
  };

  const deregisterEvents = function() {
    EventManager.resetCursor(self);
    EventManager.removeEvent(self);
    //elements.navRadius.removeClass('steps-scope-config-button-selected');
    SqftStore.radius.arcLength = 0;
    SqftStore.radius.angle = 0;
    config.highlight.points = false;
  };

  return (
    <Fragment>
      {cornersToDisplay.map((cornerToDisplay, index) => {
        const value = isRadiiFeatures ? parseInt(cornerToDisplay.part.dbFeature.sharedFeatureName) : cornerToDisplay;
        let drawCornerValue = value >= maxRadiusCorner ? maxRadiusCorner : value;
        const className = activeItemIndex === value ? 'lightbox-option-rectangular lightbox-option-selected' : 'lightbox-option-rectangular';
        return (
          <div className={className} key={index}
               onClick={(e) => handleButtonClick(e, value, cornerToDisplay)}>
            <div className={"lightbox-angle-graph lightbox-angle-graph--r" + drawCornerValue}>
              <span className="lightbox-angle-graph--horizontal"/>
              <span className="lightbox-angle-graph--vertical"/>
            </div>
            <div className="lightbox-description-text-rectangular">
              <span data-value="corner">{value}</span>
            </div>
          </div>
        )
      })}
    </Fragment>
  )
};

const mapStateToProps = (store) => {
  const {menuOpened} = store.sqftMenuState;
  const {visualizersLoaded} = store.serverState;
  return {
    menuOpened,
    visualizersLoaded,
  };
};

const mapDispatchToProps = {};


export default connect(mapStateToProps, mapDispatchToProps)(SqftNav45Corner);
